// extracted by mini-css-extract-plugin
export default {"name":"skeleton_name__OzECv"};